import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import thbRatings from "../../../../src/data/articles/cube-prospective-theros-beyond-death/thb-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  thbRatings,
  ProspectiveIntro,
  React
};